// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonWithLink_button__DXdQC"};